type GetEnvCallback = (ret: { miniprogram: boolean }) => void;

export function getEnv(callback: GetEnvCallback): void {
  const miniprogram = window.__ma_environment === 'miniprogram';
  callback({
    miniprogram
  });
}
